export const getters = {
	notifications: state => state.notifications,
	countNotifs: state => {
		if (state.notifications !== null) {
			return state.notifications.length
		} else {
			return 0
		}
	},
	open: state => state.open
}



// WEBPACK FOOTER //
// ./src/common/store/Notifications/getters.js